import { SkeletonBox, SkeletonText, SkeletonCircle } from '../primitives';
import '../primitives/Skeletons.css';

const NavBarSkeleton = () => (
  <div className="skeleton-navbar">
    <SkeletonCircle size={32} />
    <SkeletonText widths={['120px']} lineHeight="20px" />
  </div>
);

const FlashcardsSkeleton = () => {
  return (
    <div aria-hidden="true">
      <NavBarSkeleton />
      <div className="skeleton-flashcards">
        {/* Header with actions */}
        <div className="skeleton-flashcards__header">
          <SkeletonText widths={['200px']} lineHeight="24px" />
          <div style={{ display: 'flex', gap: 'var(--space-sm)' }}>
            <SkeletonBox width={100} height={36} borderRadius="var(--radius-md)" />
            <SkeletonBox width={80} height={36} borderRadius="var(--radius-md)" />
          </div>
        </div>

        {/* Flashcard placeholder */}
        <div className="skeleton-flashcards__card">
          <SkeletonText widths={['80%']} lineHeight="28px" />
          <SkeletonText lines={2} widths={['60%', '40%']} lineHeight="18px" />
        </div>

        {/* Action buttons */}
        <div className="skeleton-flashcards__actions">
          <SkeletonCircle size={56} />
          <SkeletonCircle size={56} />
          <SkeletonCircle size={56} />
        </div>

        {/* Progress indicator */}
        <div style={{ marginTop: 'var(--space-xl)', width: '100%', maxWidth: '400px' }}>
          <SkeletonBox height={8} borderRadius="var(--radius-pill)" />
          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 'var(--space-sm)' }}>
            <SkeletonText widths={['40px']} lineHeight="14px" />
            <SkeletonText widths={['40px']} lineHeight="14px" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FlashcardsSkeleton;
